import { CurrencyField } from '@aeppic/types';


export interface FormatCurrencyOptions {
  locale?: string,
}


export function formatCurrency({ currency, precision, amount }: CurrencyField, options: FormatCurrencyOptions = {}): string {
  if (currency == null) {
    return ''
  }

  return new Intl.NumberFormat(options.locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
  }).format(amount)
}